import React, { useState } from "react";
import { Button } from "@material-ui/core";
import { Lock } from "@material-ui/icons";
import { ExlyModal } from "features/Common/modules/ExlyModal/ExlyModal";
import { WHITELABELED_FOOTER } from "./constants/WhiteLabeledFooter.constants";
import { useWhitelabel } from "features/Account/modules/Whitelabel/utils/useWhitelabel";
import { WhitelabelModalDescription } from "features/Account/modules/Whitelabel/modules/WhitelabelLock/modules/WhitelabelModalDescription";
import { WhitelabelLockCta } from "features/Account/modules/Whitelabel/modules/WhitelabelLock/modules/WhitelabelLockCta/WhitelabelLockCta";
import LoadingSpinner from "schedule-v2/modals/recorded-content/LoadingSpinner";

export const WhiteLabeledFooter = ({
  className,
  textLabel,
  whiteLabelModalHeading,
  showNoButton = true,
}) => {
  const [showModal, setShowModal] = useState(false);

  const { isAccessible } = useWhitelabel();
  const [visible, setVisible] = useState(true);

  if (isAccessible === undefined) {
    return <LoadingSpinner />;
  }

  if (isAccessible || !visible) return null;

  return (
    <>
      <div
        className={`tw-bg-[#fff1d6] tw-z-[9999] tw-px-2.5 
  tw-w-[200px] sm:tw-w-[492px] tw-w-[350px] 
  tw-h-[44px] !tw-border !tw-border-solid !tw-border-[1.5px] !tw-border-[#f7ad1e] 
  tw-flex tw-justify-between tw-rounded-md tw-items-center tw-bottom-5 ${className}`}
      >
        <div className="tw-flex tw-items-center tw-gap-1">
          <Lock className="!tw-w-[13px] !tw-h-[13px] tw-text-[#f7ad1e]" />
          <div
            className="tw-font-medium tw-text-[12px] tw-leading-[100%] tw-tracking-[0.02em] tw-text-[#7f5400]"
            dangerouslySetInnerHTML={{ __html: textLabel }}
          />
        </div>
        <div className="tw-flex tw-items-center tw-gap-2">
          <Button
            onClick={() => setShowModal(true)}
            className="!tw-rounded !tw-py-1 !tw-px-2 !tw-bg-[#f7ad1e] !tw-normal-case !tw-text-white !tw-font-bold !tw-text-[12px] hover:!tw-bg-[#f7ad1e]"
          >
            {WHITELABELED_FOOTER.PROCEED_MESSAGE}
          </Button>
          {showNoButton && (
            <Button
              variant="outlined"
              onClick={() => setVisible(false)}
              className="!tw-rounded !tw-border !tw-border-[1.5px] !tw-border-[#f7ad1e] !tw-bg-[#fff1d6] !tw-py-1 !tw-px-2 !tw-normal-case !tw-text-black !tw-font-bold !tw-text-[12px] hover:!tw-bg-[#fff1d6]"
            >
              {WHITELABELED_FOOTER.REJECT_MESSAGE}
            </Button>
          )}
        </div>
      </div>

      {showModal && (
        <ExlyModal
          open={showModal}
          showSecondaryBtn={false}
          onClose={() => setShowModal(false)}
          primaryBtnFullWidth
          customFooter={
            <div className="tw-p-6 tw-border-t-[1.5px] tw-border-[#e7e6e4]">
              <WhitelabelLockCta onClose={() => setShowModal(false)} />
            </div>
          }
          modal_props={{
            modalPaperClassName: "!tw-min-w-[480px] !tw-max-w-[480px]",
          }}
          title="Pay & Unlock"
        >
          <WhitelabelModalDescription
            modalDescription={{
              heading: whiteLabelModalHeading,
            }}
          />
        </ExlyModal>
      )}
    </>
  );
};
